import VueCurrencyFilter from "vue-currency-filter";

Vue.use(VueCurrencyFilter, [
  {
    name: 'currency',
    symbol: "€",
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'end',
    symbolSpacing: true,
  },
  {
    name: 'currency_no_decimals',
    symbol: "€",
    thousandsSeparator: '.',
    fractionCount: 0,
    fractionSeparator: ',',
    symbolPosition: 'end',
    symbolSpacing: true,
  }
 ])
